import SkillApi from '@/api/skill/skill.js'
import { apiUrl } from '@/api/base.js'

const state = {
    skills: [],
    skill_category: [],
    skill_category_info: [{0:1,1:2,2:3},{0:2,1:5,2:8}],
    current_category: '',
    star: {},
    url: `${apiUrl}v2/post_skill_submit_file/`
}

const mutations = {
    get_self_score (state, skills) {
        state.skills = skills
    },
    get_categories (state, category) {
        state.skill_category = category
    },
    get_skill_from_category(state, skills){
        state.skills = skills
    },
    set_current_category(state, category){
        state.current_category = category
    },
    skill_category_info(state, category){
        state.skill_category_info = category
    },
    set_star(state, star){
        var obj = Object.create(state.star)
        obj[star[1]] = star[0]
        state.star = obj
    },
    reset_star(state, star){
        state.star = star
    },
    set_skill_display(state, skill_id) {
        var obj = Object.create(state.skills)
        for(let i = 0; i<obj.length; i++){
            if(obj[i].id === skill_id){
                obj[i].display = false
            }
        }
        console.log(state.skills)
        state.skills = obj
        // state.skills[skill_id].display = false
    }
}
const actions = {
    async get_self_score (context) {
        let res = await SkillApi.get_self_score()
        context.commit('get_self_score', res.data)
    },
    async get_skill_category_info (context) {
        let res = await SkillApi.get_skill_category_info()
        context.commit('skill_category_info', res.data)
    },
    async set_test (context, event) {
        context.commit('skill_category_info', event.target.value)
    },
    async set_skill_display (context, skill_id) {
        // console.log(skill_id)
        context.commit('set_skill_display', skill_id)
    },
    async check_user_skill () {
        await SkillApi.check_user_skill()
    },
    async upload_data (context) {
        // await SkillApi.check_user_skill()
        // console.log(event.target[0].files)
        // let temp = new FormData(event.target[0])
        // temp.append('file', event.target[0].files[0])
        await SkillApi.post_skill_submit_file()
    },

    async change_current_category (context, category) {
        context.commit('set_current_category', category)
        let skills = await SkillApi.get_skill_from_category_for_submit(state.current_category.id)
        context.commit('get_skill_from_category', skills.data)
    },
    async get_categories (context) {
        let domain = localStorage.getItem('field')
        let res = await SkillApi.get_categories({'domain': domain})
        let obj = JSON.parse(res.data.result)
        context.commit('get_categories', obj)
        context.commit('set_current_category', obj[0])
        let skills = await SkillApi.get_skill_from_category_for_submit(context.state.current_category.id)
        context.commit('get_skill_from_category', skills.data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
